import { USAGE_ACTION } from '../constants/sample.constants';

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export type UsageActionDisplaySource = {
  isCreationRecord?: boolean;
  action?: string | null;
  purpose?: string | null;
};

/** 使用履歴の種別ラベル（作成／使用／廃棄など） */
export function formatUsageRecordActionLabel(
  record: UsageActionDisplaySource,
  t: TranslateFn
): string {
  if (record.isCreationRecord) {
    return t('sample.action_created');
  }
  if (record.action) {
    switch (record.action) {
      case USAGE_ACTION.USE:
        return t('usage_record.action_use');
      case USAGE_ACTION.DISPOSE:
        return t('usage_record.action_dispose');
      case USAGE_ACTION.MOVE:
        return t('usage_record.action_move');
      case USAGE_ACTION.OTHER:
        return t('usage_record.action_other');
      case USAGE_ACTION.CREATED:
        return t('sample.action_created');
      default:
        return record.action;
    }
  }
  if (record.purpose) return record.purpose;
  return t('sample.action_used');
}

/** Bootstrap Badge の bg（作成は success を呼び出し側で別扱い） */
export function usageActionBadgeBg(action: string | null | undefined): string {
  if (action === USAGE_ACTION.USE) return 'primary';
  if (action === USAGE_ACTION.DISPOSE) return 'danger';
  return 'warning';
}
